import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { GET } from "../../service/api";

export type Customer = {
  id: string;
  name: string;
  customer_id: string;
};

type CustomersState = {
  list: Customer[];
  loading: boolean;
  error: string | null;
  lastFetched?: number;
};

type CustomerPayloadAction = {
  data: { data: Customer[] };
};

const initialState: CustomersState = {
  list: [],
  loading: false,
  error: null,
};

const CustomersDropdownListSlice = createSlice({
  name: "customers",
  initialState,
  reducers: {
    clearCustomers(state) {
      state.list = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GET("customers/search-customers", "").pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        GET("customers/search-customers", "").fulfilled,
        (state, action: PayloadAction<CustomerPayloadAction>) => {
          state.loading = false;
          state.list = action.payload?.data?.data || [];
          state.lastFetched = Date.now();
        },
      )
      .addCase(
        GET("customers/search-customers", "").rejected,
        (state, action) => {
          state.loading = false;
          state.error = "Failed to load customers";
        },
      );
  },
});

export const { clearCustomers } = CustomersDropdownListSlice.actions;
export default CustomersDropdownListSlice.reducer;
